import { motion } from "framer-motion";
import { useHome } from "@/context/HomeContent";

const Row = ({ words }) => (
  <div className="flex shrink-0 items-center">
    {words.map((w, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-12 font-heading font-bold text-4xl text-brand-ink/25 sm:text-6xl lg:text-7xl">{w}</span>
        <span className="h-2.5 w-2.5 shrink-0 rounded-full bg-brand-magenta/40" />
      </span>
    ))}
  </div>
);

const Marquee = () => {
  const { home } = useHome();
  const words = home.marquee || [];
  return (
    <section data-testid="marquee-section" className="overflow-hidden border-y border-brand-line bg-brand-cream py-10" aria-hidden="true">
      <motion.div className="flex w-max" animate={{ x: ["0%", "-50%"] }} transition={{ duration: 34, ease: "linear", repeat: Infinity }}>
        <Row words={words} />
        <Row words={words} />
      </motion.div>
    </section>
  );
};

export default Marquee;
